import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import * as PageConstants from '../../../constants/PageTitle';
import '../Technical.css';

class UploadImage extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        {PageConstants.Upload_Image_TITLE}</h1>
                    <div>
                        <h2 className="main-subheading">
                            Methods</h2>
                            <ul>
                                <li className="technical-list-item"><Link to="/technical/uploadimage/sendimage">SendImage</Link></li>
                                <li className="technical-list-item"><Link to="/technical/uploadimage/sendImageWithDataCapture">SendImageWithDataCapture</Link></li>
                            </ul>
                            <br />
                    </div>
                    <div>
                        <h2 className="main-subheading">
                        IP Transparency Check </h2>
                        <div className="technical-main-content">
                           <p>The IP transparency check is for allowing service requests only to the intended requesters. The legitimacy of a requester is configured by making a setting entry into either financial institute or partner or product setting table. The setting key is AAM_UploadImage_WS_IP_Restrict. The value of the settings will be a semi-colon delimited (&quot;;&quot;) string of IPs.</p>
                           <p>Product setting has the highest priority then the partner and then financial institute setting table.  The IP transparency check only comes into effect if any of the setting table (product, partner or financial institute) has an entry against key AAM_UploadImage_WS_IP_Restrict.</p>
                           </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UploadImage;

